import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgArtistBadge = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 64, height: 16, viewBox: "0 0 64 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_46_5166)" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M62 0C63.1046 0 64 0.89543 64 2V14C64 15.1046 63.1046 16 62 16H2C0.89543 16 0 15.1046 0 14V2C0 0.89543 0.89543 0 2 0H62ZM42.885 4.74C42.405 4.74 42.405 4.74 41.94 4.865C41.475 4.99 41.475 4.99 41.11 5.245C40.745 5.5 40.745 5.5 40.52 5.89C40.295 6.28 40.295 6.28 40.295 6.82C40.295 7.32 40.295 7.32 40.455 7.655C40.615 7.99 40.615 7.99 40.87 8.22C41.125 8.45 41.125 8.45 41.445 8.59C41.765 8.73 41.765 8.73 42.085 8.83C42.415 8.94 42.415 8.94 42.715 9.04C43.015 9.14 43.015 9.14 43.235 9.275C43.455 9.41 43.455 9.41 43.585 9.595C43.715 9.78 43.715 9.78 43.715 10.06C43.715 10.35 43.715 10.35 43.6 10.545C43.485 10.74 43.485 10.74 43.3 10.87C43.115 11 43.115 11 42.885 11.055C42.655 11.11 42.655 11.11 42.435 11.11C42.015 11.11 42.015 11.11 41.58 10.9C41.232 10.732 41.232 10.732 40.996 10.468L40.885 10.33L39.985 11.17C40.405 11.67 40.405 11.67 41.065 11.925C41.725 12.18 41.725 12.18 42.415 12.18C42.935 12.18 42.935 12.18 43.405 12.04C43.875 11.9 43.875 11.9 44.225 11.62C44.575 11.34 44.575 11.34 44.785 10.915C44.995 10.49 44.995 10.49 44.995 9.92C44.995 9.4 44.995 9.4 44.8 9.05C44.605 8.7 44.605 8.7 44.3 8.47C43.995 8.24 43.995 8.24 43.63 8.1C43.265 7.96 43.265 7.96 42.925 7.85C42.625 7.76 42.625 7.76 42.375 7.67C42.125 7.58 42.125 7.58 41.95 7.46C41.775 7.34 41.775 7.34 41.675 7.17C41.575 7 41.575 7 41.575 6.76C41.575 6.5 41.575 6.5 41.69 6.315C41.805 6.13 41.805 6.13 41.985 6.015C42.165 5.9 42.165 5.9 42.385 5.845C42.605 5.79 42.605 5.79 42.825 5.79C43.195 5.79 43.195 5.79 43.56 5.965C43.852 6.105 43.852 6.105 44.0384 6.2994L44.125 6.4L44.945 5.5C44.535 5.12 44.535 5.12 43.98 4.93C43.425 4.74 43.425 4.74 42.885 4.74ZM12.095 4.92H11.005L7.925 12H9.335L9.975 10.38H13.045L13.705 12H15.145L12.095 4.92ZM20.805 4.92H18.345V12H19.605V9H20.525L22.165 12H23.685L21.795 8.86C22.545 8.69 22.545 8.69 22.98 8.205C23.415 7.72 23.415 7.72 23.415 6.95C23.415 6.39 23.415 6.39 23.195 6C22.975 5.61 22.975 5.61 22.61 5.37C22.245 5.13 22.245 5.13 21.775 5.025C21.4225 4.94625 21.4225 4.94625 21.0531 4.92656L20.805 4.92ZM31.875 4.92H26.275V6.02H28.445V12H29.705V6.02H31.875V4.92ZM36.455 4.92H35.195V12H36.455V4.92ZM53.455 4.92H47.855V6.02H50.025V12H51.285V6.02H53.455V4.92ZM11.515 6.42L12.605 9.3H10.405L11.515 6.42ZM20.745 5.98C20.985 5.98 20.985 5.98 21.24 6.02C21.495 6.06 21.495 6.06 21.695 6.17C21.895 6.28 21.895 6.28 22.025 6.465C22.155 6.65 22.155 6.65 22.155 6.94C22.155 7.26 22.155 7.26 22.015 7.465C21.875 7.67 21.875 7.67 21.66 7.78C21.445 7.89 21.445 7.89 21.175 7.93C20.905 7.97 20.905 7.97 20.635 7.97H19.605V5.98H20.745Z", fill: props.fill })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_46_5166" }, /* @__PURE__ */ React.createElement("rect", { width: 64, height: 16, fill: "white" }))));
});
export default SvgArtistBadge;
